import { useState, useRef, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { getPQRonEdit } from "../../Services/pqr-header-service";
import { PQRHeader_Tube } from "./PQRObjects/PQR_entity";
import { Action, Status, MessageTypes } from "../utility/common/constants/CommonConstants";
import { createTestObjectArray, TEST_TEMPLATES, createPQRComplexTableStructure } from "../utility/common/TransactionComponents/TransactionValidationUtils";
import { getPQRDetailsEdit } from "../../Services/pqr-details-service";
import PQRTubesheetPage1 from "./PQRTubesheetPage1";
import PQRTubesheetPage2 from "./PQRTubesheetPage2";
import PQRTubesheetPage3 from "./PQRTubesheetPage3";
import { bluestyle, errorstyle, normalstyle } from "../../functions/welding-functions";
import { NavigationButtons } from "../utility/ui/navigation/TransactionNavigation/NavigationButtons";
import { showToast, executeChildFunction, handleNavigation, getTabStyle } from "../utility/ui/navigation/TransactionNavigation/TransactionUtils";
import { DisableFields } from "../WPSTransaction/WPSObjects/WPSCommonUtils";

const PQRTubeSheetTransaction = () => {
  const [key, setKey] = useState(1);
  const firstChildRef = useRef();
  const secondChildRef = useRef();
  const thirdChildRef = useRef();
  const location = useLocation();
  let UserName = sessionStorage.getItem("UserName");
  let UserId = sessionStorage.getItem("UserId");
  const [copydata, setcopydata] = useState("");
  const [action, setaction] = useState(location.state?.action);
  const [originalaction] = useState(location.state?.action);
  const [WPStype] = useState(location.state?.WPStype);
  const [headerloaded, setheaderloaded] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isReadonly, setIsReadonly] = useState(false);
  const [testObj, setTestObj] = useState([]);
  const [processObj, setprocessObj] = useState([]);
  const [headerObj, setheaderObj] = useState(
    action === Action.ActionEdit || action === Action.ActionCopy
      ? location.state?.data
      : PQRHeader_Tube(WPStype)
  );



  useEffect(() => {
    let read = DisableFields(headerObj.WPSH_Status, headerObj.WPSH_Prepared_By, Status, Action, action)
    setIsReadonly(read);
    setIsDisabled(read);
  }, [action]);

  const [detailObj, setdetailObj] = useState(
    action === Action.ActionEdit || action === Action.ActionCopy
      ? location.state?.data
      : {
        SK: "",
        PK: "",
        PQR_Process: "GTAW",
        WPSD_FM_SFA: "",
        WPSD_FM_Classification: "",
        WPSD_FM_FNo: "",
        WPSD_FM_Ano: "",
        WPSD_FM_ChemicalAnalysis_TradeName: "",
        wld_createdby: "",
        wld_createdon: "",
        wld_updatedby: "",
        wld_updatedon: "",
        PQRD_WP_WeldingProcess: "GTAW",
        PQRD_WP_Type: "",
        PQRD_WP_MinimumPreheatTemp: "",
        PQRD_WP_MaximumInterpassTemp: "",
        PQRD_WP_PostHeating: "",
        PQRD_WP_TungstenType: "",
        PQRD_WP_WeldPosition: "",
        PQRD_WP_WeldProgression: "",
        PQRD_WP_NoofPasses: "",

        PQRD_WP_ArcVoltageControl: "",
        PQRD_WP_ShieldingGasType: "",
        PQRD_WP_ShieldingFlowRate: "",

        PQRD_WP_Auxiliarygas: "",
        PQRD_WP_Expansion: "",
        PQRD_WP_MethodofCleaning: "",
        PQRD_WP_SingleMultiElectrode: ["", ""],
        PQRD_WP_Peening: ["", ""],
        PQRD_WP_ThermalProcess: ["", ""],
        PQRD_WP_StringWeave: ["", ""],
        PQRD_WP_Oscillation: ["", ""],
        PQRD_WP_OrificeCupSize: ["", ""],
        PQRD_WP_ClosedOutChamber: ["", ""],
        PQRD_WP_LayerNo: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
        PQRD_WP_FillerMetalSize: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
        PQRD_WP_Amperes: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
        PQRD_WP_DC_Pulsing_current: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
        PQRD_WP_DC_Pulsing_current_Others: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
        PQRD_WP_Volatage_Volts: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
        PQRD_WP_Travel_Speed: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
        PQRD_WP_Heat_Input: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
        PQRD_WP_PolarityOrCurrent: [{ Value_A: [""] }, { Value_B: [""] }]
      }
  );

  const initializeTestObjects = () => {
    return {
      Visual_Examination: Visual_Examination_Obj(4),
      Liquid_Penetrant_Examination: Liquid_Penetrant_Examination_Obj(4),
      Macro_Examination: Macro_Examination_Obj(4),
      Minimum_Leak_Path: Minimum_Leak_Path_Obj(8),
      Tear_Test: Tear_Test_Obj(4),
      PullOut_Test: PullOut_Test_Obj(4),
      PullOut_Test_Table: PullOut_Test_Table_Obj(4),
      Hardness_Test: Hardness_Test_Obj(9),
      Radiography_Test: Radiography_Test_Obj(4),
      Other_Test: Other_Test_Obj(4),
      Certification: Certification_Obj(4)
    };
  };

  const getTestObject = (testName, defaultObj) => {
    if (headerObj[testName] === undefined) return defaultObj;
    const existing = headerObj[testName];
    if (Array.isArray(existing) && Array.isArray(defaultObj) && existing.length < defaultObj.length) {
      return [...existing, ...defaultObj.slice(existing.length)];
    }
    return existing;
  };

  const initializeEditMode = async () => {
    const IdprojectPK = location.state?.data.PK;
    const IdprojectSK = location.state?.data.PQR_RecordNo;
    const IdPK = location.state?.data.WPSH_PQR_Process;
    const IdSK = location.state?.data.WPSH_PQR_Type;
    fetchprojectbyid(IdprojectPK, IdprojectSK);
    fetchbyid(IdprojectPK, IdprojectSK, IdPK, IdSK);
  };

  useEffect(() => {
    if (action === Action.ActionAdd) {
      const testObjects = initializeTestObjects();
      setdetailObj({ ...detailObj });
      setheaderObj({ ...headerObj, ...testObjects });
    } else {
      initializeEditMode();
    }
  }, []);

  useEffect(() => {
    const testObjects = initializeTestObjects();
    const updatedHeaderObj = { ...headerObj };
    Object.keys(testObjects).forEach(key => {
      updatedHeaderObj[key] = getTestObject(key, testObjects[key]);
    });
    console.log("initializeEditMode", updatedHeaderObj)
    setheaderObj(updatedHeaderObj);
  }, [headerloaded])

  function Visual_Examination_Obj(count) {
    return createTestObjectArray(count, TEST_TEMPLATES.PQR_VISUAL_EXAMINATION);
  }

  function Liquid_Penetrant_Examination_Obj(count) {
    return createTestObjectArray(count, TEST_TEMPLATES.PQR_LIQUID_PENETRANT_EXAMINATION);
  }

  function Certification_Obj(count) {
    return createTestObjectArray(count, TEST_TEMPLATES.PQR_CERTIFICATION);
  }

  function Macro_Examination_Obj(count) {
    return createPQRComplexTableStructure(count, TEST_TEMPLATES.PQR_MACRO_EXAMINATION, TEST_TEMPLATES.PQR_MACRO_EXAMINATION_TABLE10, ['Table6', 'Table7', 'Table10']);
  }

  function Minimum_Leak_Path_Obj(count) {
    return createPQRComplexTableStructure(count, TEST_TEMPLATES.PQR_MINIMUM_LEAK_PATH, TEST_TEMPLATES.PQR_MINIMUM_LEAK_PATH_TABLE5, ['Table1', 'Table2', 'Table5']);
  }

  function Tear_Test_Obj(count) {
    return createTestObjectArray(count, TEST_TEMPLATES.PQR_TEAR_TEST);
  }

  function PullOut_Test_Obj(count) {
    return createTestObjectArray(count, TEST_TEMPLATES.PQR_PULLOUT_TEST);
  }

  function PullOut_Test_Table_Obj(count) {
    return createTestObjectArray(count, TEST_TEMPLATES.PQR_PULLOUT_TEST_TABLE);
  }

  function Hardness_Test_Obj(count) {
    return createTestObjectArray(count, TEST_TEMPLATES.PQR_HARDNESS_TEST);
  }

  function Radiography_Test_Obj(count) {
    return createTestObjectArray(count, TEST_TEMPLATES.RADIOGRAPHY_TEST);
  }

  function Other_Test_Obj(count) {
    return createTestObjectArray(count, TEST_TEMPLATES.OTHER_TEST);
  }

  const [logObj, setlogObj] = useState({
    WPSH_Project_No_log:
      headerObj !== undefined ? headerObj.WPSH_Project_No : "",
    WPSH_WPS_No_log: headerObj !== undefined ? headerObj.WPSH_WPS_No : "",
    WPSH_User_Name_log: UserName,
    WPSH_User_Id_log: UserId,
    WPSH_Status_log: "",
  });


  const padInnerTable = (existing, count, template) => {
    if (!Array.isArray(existing) || existing.length < count) {
      const padded = [...(existing || [])];
      while (padded.length < count) padded.push({ ...template });
      return padded;
    }
    return existing;
  };

  const fetchprojectbyid = async (IdprojectPK, IdprojectSK, fectchcomplete) => {
    let reqData = {
      WPStype: WPStype,
      IdprojectPK: IdprojectPK,
      IdprojectSK: IdprojectSK,
    };
    const result = await getPQRonEdit(reqData);
    if (result !== undefined && result[0] !== undefined) {
      const fetched = result[0];
      if (fetched.Minimum_Leak_Path?.[0]) {
        const mlp = fetched.Minimum_Leak_Path[0];
        mlp.Table1 = padInnerTable(mlp.Table1, 8, TEST_TEMPLATES.PQR_MINIMUM_LEAK_PATH);
        mlp.Table2 = padInnerTable(mlp.Table2, 8, TEST_TEMPLATES.PQR_MINIMUM_LEAK_PATH);
        mlp.Table5 = padInnerTable(mlp.Table5, 4, TEST_TEMPLATES.PQR_MINIMUM_LEAK_PATH_TABLE5);
      }
      setheaderObj(fetched);
    }
    setheaderloaded(true);
  };

  //this is for existing data in input fields on edit
  const normalizeDetailArrayFields = (detail) => {
    const threeValueFields = [
      "PQRD_WP_LayerNo", "PQRD_WP_FillerMetalSize", "PQRD_WP_Amperes",
      "PQRD_WP_DC_Pulsing_current", "PQRD_WP_DC_Pulsing_current_Others",
      "PQRD_WP_Volatage_Volts", "PQRD_WP_Travel_Speed", "PQRD_WP_Heat_Input"
    ];
    const defaults = [
      { Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }
    ];
    threeValueFields.forEach((field) => {
      if (!detail[field] || !Array.isArray(detail[field])) {
        detail[field] = [...defaults.map(d => ({ ...d, [Object.keys(d)[0]]: [""] }))];
      } else {
        if (!detail[field][0]?.Value_A) detail[field][0] = { Value_A: [""] };
        if (!detail[field][1]?.Value_B) detail[field][1] = { Value_B: [""] };
        if (!detail[field][2]?.Value_C) detail[field][2] = { Value_C: [""] };
      }
    });
    if (!detail.PQRD_WP_PolarityOrCurrent || !Array.isArray(detail.PQRD_WP_PolarityOrCurrent)) {
      detail.PQRD_WP_PolarityOrCurrent = [{ Value_A: [""] }, { Value_B: [""] }];
    } else {
      if (!detail.PQRD_WP_PolarityOrCurrent[0]?.Value_A) detail.PQRD_WP_PolarityOrCurrent[0] = { Value_A: [""] };
      if (!detail.PQRD_WP_PolarityOrCurrent[1]?.Value_B) detail.PQRD_WP_PolarityOrCurrent[1] = { Value_B: [""] };
    }

    const twoValueFields = [
      "PQRD_WP_SingleMultiElectrode", "PQRD_WP_Peening", "PQRD_WP_ThermalProcess",
      "PQRD_WP_StringWeave", "PQRD_WP_Oscillation", "PQRD_WP_OrificeCupSize",
      "PQRD_WP_ClosedOutChamber"
    ];
    twoValueFields.forEach((field) => {
      if (!detail[field] || !Array.isArray(detail[field])) {
        const oldVal = detail[field] || "";
        detail[field] = [oldVal, ""];
      }
    });

    return detail;
  };

  const fetchbyid = async (IdprojectPK, IdprojectSK, IdPK, IdSK) => {
    let reqData = {
      WPStype: WPStype,
      IdprojectPK: IdprojectPK,
      IdprojectSK: IdprojectSK,
      IdPK: IdPK,
      IdSK: IdSK,
    };
    const result = await getPQRDetailsEdit(reqData);
    const detail = result[0];
    setdetailObj(normalizeDetailArrayFields(detail));
  };

  useEffect(() => {
    if (action === Action.ActionCopy) {
      setcopydata(true);
    }
  }, []);


  const next = async (e) => {
    const refs = [firstChildRef, secondChildRef, thirdChildRef];
    const funcNames = ['funcOnNext', 'funcOnNext2', 'funcOnNext3'];
    const funcName = funcNames[key - 1];
    const res = await executeChildFunction(refs, key, funcName);
    showToast(res, key, setKey, 3, true);
  };

  const handleSelect = (e) => {
    Temp(e, "tab");
  };

  const Temp = async (e, tabaction) => {
    const refs = [firstChildRef, secondChildRef, thirdChildRef];
    const funcNames = ['funcOnNextTemp', 'funcOnNextTemp2', 'funcOnNextTemp3'];
    const funcName = funcNames[key - 1];
    const res = await executeChildFunction(refs, key, funcName);
    showToast(res, key, setKey, 3, true);
    if (res === MessageTypes.Temp || res === MessageTypes.None) {
      handleNavigation(tabaction, e, key, setKey, 3);
    }
  };

  return (
    <>
      <div className="position-absolute ms-3" style={{ top: "15px" }}>
        <strong>Add New</strong>
        <span className="ms-1 warning-text" style={{ fontSize: "small" }} >
          (All fields are mandatory)
        </span>
      </div>
      <div className="border-divider" />
      <div className="mt-4">
        <div style={{ borderBottom: "2px solid var(--col-ddd)", position: "relative", top: "34px", zIndex: "-2" }}></div>
        <Tabs
          activeKey={key}
          onSelect={(e) => handleSelect(e)}
          className="mb-2 w-100 border-end"
          fill
        >
          <Tab
            eventKey={1}
            title="PQR Page 1"
            style={getTabStyle()}
          >
            <PQRTubesheetPage1
              ref={firstChildRef}
              headerObj={headerObj}
              setheaderObj={setheaderObj}
              detailObj={detailObj}
              setdetailObj={setdetailObj}
              normalstyle={normalstyle}
              errorstyle={errorstyle}
              bluestyle={bluestyle}
              WPStype={WPStype}
              setKey={setKey}
              tabno={key}
              isDisabled={isDisabled}
              isReadonly={isReadonly}
              setIsReadonly={setIsReadonly}
              action={action}
              setaction={setaction}
              setIsDisabled={setIsDisabled}
            />
          </Tab>
          <Tab
            eventKey={2}
            title="PQR Page 2"
            style={getTabStyle()}
            disabled={action == Action.ActionAdd || action == Action.ActionCopy ? true : false}
          >
            <PQRTubesheetPage2
              ref={secondChildRef}
              processObj={processObj}
              setprocessObj={setprocessObj}
              headerObj={headerObj}
              setheaderObj={setheaderObj}
              detailObj={detailObj}
              setdetailObj={setdetailObj}
              copydata={copydata}
              WPStype={WPStype}
              logObj={logObj}
              setKey={setKey}
              tabno={key}
              setlogObj={setlogObj}
              isDisabled={isDisabled}
              isReadonly={isReadonly}
              setIsReadonly={setIsReadonly}
              action={action}
              setaction={setaction}
            />
          </Tab>
          <Tab
            eventKey={3}
            title="PQR Page 3"
            style={getTabStyle()}
            disabled={action == Action.ActionAdd || action == Action.ActionCopy ? true : false}
          >
            <PQRTubesheetPage3
              ref={thirdChildRef}
              headerObj={headerObj}
              setheaderObj={setheaderObj}
              detailObj={detailObj}
              setdetailObj={setdetailObj}
              testObj={testObj}
              setTestObj={setTestObj}
              copydata={copydata}
              WPStype={WPStype}
              logObj={logObj}
              setKey={setKey}
              tabno={key}
              setlogObj={setlogObj}
              isDisabled={isDisabled}
              isReadonly={isReadonly}
              setIsReadonly={setIsReadonly}
              action={action}
              setaction={setaction}
            />
          </Tab>
        </Tabs>

        <NavigationButtons
          currentKey={key}
          maxTabs={3}
          isBtnDisabled={isDisabled}
          originalAction={originalaction}
          onNext={next}
          onTemp={Temp}
        />
      </div>
    </>
  );
};

export default PQRTubeSheetTransaction;